import { useState } from "react";

function Curric({title,children}) {

    const [visible,setVisible] = useState(false)

    const changeVisible = () => {
        setVisible(oldState => !oldState)
    }

    return (
        <>
            <button type="button" className="collapsible" onClick={changeVisible}>{title}</button>
            <div className={"content "+ (visible ? 'visible': "invisible") }>
                {children}
            </div>
        </>
    );
}

export default Curric;